import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

export const StTagInfo = styled(Grid)(({ theme }) => ({
  borderRadius: '5px',
  color: '#FFF',
  fontFamily: theme?.palette?.primaryFontFamilyType || 'Proxima Nova',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: '500',
  alignSelf: 'center',
  padding: '2px 6px',
  marginRight: '0.5rem',
}));

export const StHTMLDescription = styled(Grid)(() => ({
  color: '#444',
  fontWeight: '500',
  lineHeight: '33px',
  marginBottom: '24px',
}));
